import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";

const AdminGuard = ({ children }) => {
  const { user, isLoggedIn } = useAuth();

  if (
    isLoggedIn &&
    user &&
    (user.role !== "MASTER" || user.canViewAdmin === false)
  ) {
    return <Navigate to="/dashboard/default" replace />;
  }

  return children;
};

AdminGuard.propTypes = {
  children: PropTypes.node,
};

export default AdminGuard;
